// extracted by mini-css-extract-plugin
export default {"Main":"confirmEmail__Main__R5z3L"};